<template>
  <div class="dateSelector">
    <div class="note">
      1. 請先選擇欲指定日期的範圍<br>2. 再在下方日曆中選取欲指定日期
    </div>
    <div>
      <rangeInput :style="{margin: 0, width: '360px'}" :size="'sm'" :defaultValue="range" @input="changeRange"
      :shortcuts="shortcuts"/>
      <div :style="{marginInline: 'auto'}"></div>
      <button class="clear" @click="dateSelect=[]">清空</button>
      <button class="save" @click="$emit('input', Array.from(new Set(dateSelect)))">確定</button>
    </div>
    <div class="calendarBox" :style="{gridTemplateColumns: `repeat(${repeat}, 1fr)`}">
      <MonthVue v-for="m in months" :key="`month-${m}`" :start="moment(range.start).add(m - 1, 'month').startOf('month').format('YYYY-MM-DD')">
        <label slot-scope="{d:{d, f}}" :for="f" :class="dateSelect.includes(f) ? 'selected' : ''"><input type="checkbox" :id="f" v-model="dateSelect" :value="f" >{{d}}</label>
      </MonthVue>
    </div>
  </div>
</template>

<script>
import MonthVue from './month.vue'
import rangeInput from '../../../components/input/dateRangeWithShortCuts.vue'
export default {
  components: { rangeInput, MonthVue },
  props: ['dates'],
  data () {
    return {
      range: { start: null, end: null },
      dateSelect: [],
      shortcuts: [
        { key: 'M1', label: '本月', value: 'month', isSelected: true },
        { key: 'MN1', label: '下個月', value: () => { return { start: this.moment().add(1, 'month').startOf('month'), end: this.moment().add(1, 'month').endOf('month') } }, isSelected: false },
        { key: 'M2', label: '後兩月', value: () => { return { start: this.moment().startOf('month'), end: this.moment().add(1, 'month').endOf('month') } }, isSelected: false },
        { key: 'M3', label: '後兩月', value: () => { return { start: this.moment().startOf('month'), end: this.moment().add(2, 'month').endOf('month') } }, isSelected: false },
        { key: 'Y', label: '本年度', value: () => { return { start: this.moment().startOf('month'), end: this.moment().endOf('year') } }, isSelected: false },
        { key: 'YN1', label: '下年度', value: () => { return { start: this.moment().add(1, 'year').startOf('year'), end: this.moment().add(1, 'year').endOf('year') } }, isSelected: false }
      ]
    }
  },
  mounted () {
    this.initial()
  },
  watch: {
    dates () {
      this.initial()
    }
  },
  computed: {
    months () {
      const m = this.moment(this.range.end).diff(this.moment(this.range.start), 'month')
      return (isNaN(m) ? -1 : m) + 1
    },
    repeat () {
      switch (this.months) {
        case 1:
          return 1
        case 2:
          return 2
        case 3:
          return 3
        case 4:
          return 2
        default:
          return 3
      }
    }
  },
  methods: {
    changeRange (ev) {
      console.log('[changeRange]', ev)
      if (ev.start && ev.end) {
        this.range = ev
        console.log('[changeRanage]', 'changed')
      }
    },
    initial () {
      if (this.dates && this.dates.length > 0) {
        const dates = JSON.parse(JSON.stringify(this.dates))
        dates.sort((a, b) => this.moment(a).isBefore(this.moment(b)) ? -1 : 1)
        console.log({
          start: this.moment(dates[0]).startOf('month').format('YYYY-MM-DD'),
          end: this.moment(dates.slice(-1)[0]).endOf('month').format('YYYY-MM-DD')
        })
        this.range.start = this.moment(dates[0]).startOf('month').format('YYYY-MM-DD')
        this.range.end = this.moment(dates.slice(-1)[0]).endOf('month').format('YYYY-MM-DD')
        this.dateSelect = dates
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.note {
  text-align: start;
  font-size: 18px;
  color: #5E5E5E;
  line-height: 1.5em;
}
label {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  &.selected {
    background-color: var(--highlight);
    opacity: .8;
    color: #FFFFFF;
  }
  input[type=checkbox] {
    appearance: none;
    display: none;
  }
}
button.clear {
  width: 100px;
  height: 40px;
  background-color: #cacaca;
  letter-spacing: 2px;
  color: #FFFFFF;
  border-radius: 3px;
}
button.save {
  width: 100px;
  height: 40px;
  background-color: var(--highlight);
  letter-spacing: 2px;
  color: #FFFFFF;
  border-radius: 3px;
}
.dateSelector {
  padding: 20px;
  display: grid;
  grid-template-rows: 3em 45px 1fr;
  min-width: 600px;
  gap: 20px;
  &>div:nth-child(2) {
    display: flex;
    align-items: center;justify-content: flex-start;
    gap: 20px;
  }
}
.calendarBox {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-height: 560px;
  overflow-y: auto;
  gap: 10px;
  margin-inline: auto;
  &>div {
    height: fit-content;
  }
}
</style>
